module.exports = __webpack_public_path__ + "img/sea-burial-success.b185390a.png";